/**
 *
 *  Popover/Events module
 *
 *  Close all popover on click elsewhere
 *
 */

'use strict';

const _ = require('lodash');

const PopinManager = require('./../');

module.exports.onOverlayClick = function() {
    _.forEach(PopinManager.getAll(), function(popin) {
        if (popin instanceof require('./') &&
                !popin.rootElement.dialog('widget').hasClass('prevent-click') &&
                (popin.rootElement.dialog('widget').hasClass('cloud-dialog-popover') || popin.rootElement.dialog('widget').hasClass('content-dialog'))) {
            popin.hide();
        }
    });
};
